// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function details_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var key = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "key"), null));
  if (key.TAG === /* Ok */0) {
    var value = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "value"), null));
    if (value.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                key: key._0,
                value: value._0
              }
            };
    }
    var e = value._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".value" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = key._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".key" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function icons_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var map_marker = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "map_marker"), null));
  if (map_marker.TAG === /* Ok */0) {
    var selected = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "selected"), null));
    if (selected.TAG === /* Ok */0) {
      var deselected = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "deselected"), null));
      if (deselected.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  map_marker: map_marker._0,
                  selected: selected._0,
                  deselected: deselected._0
                }
              };
      }
      var e = deselected._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".deselected" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = selected._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".selected" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = map_marker._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".map_marker" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function service_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var is_enabled = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_enabled"), null));
  if (is_enabled.TAG === /* Ok */0) {
    var service_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_type"), null));
    if (service_type.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                is_enabled: is_enabled._0,
                service_type: service_type._0
              }
            };
    }
    var e = service_type._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".service_type" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = is_enabled._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".is_enabled" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function value_added_service_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var vas_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vas_type"), null));
  if (vas_type.TAG === /* Ok */0) {
    var off_messages = Decco.optionFromJson((function (param) {
            return Decco.arrayFromJson(Decco.stringFromJson, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "off_messages"), null));
    if (off_messages.TAG === /* Ok */0) {
      var services = Decco.arrayFromJson(service_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "services"), null));
      if (services.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  vas_type: vas_type._0,
                  off_messages: off_messages._0,
                  services: services._0
                }
              };
      }
      var e = services._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".services" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = off_messages._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".off_messages" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = vas_type._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".vas_type" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function allowed_goods_type_name_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
    if (name.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                id: id._0,
                name: name._0
              }
            };
    }
    var e = name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".name" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function on_demand_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var display_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "display_name"), null));
    if (display_name.TAG === /* Ok */0) {
      var details = Decco.arrayFromJson(details_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "details"), null));
      if (details.TAG === /* Ok */0) {
        var icons = icons_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "icons"), null));
        if (icons.TAG === /* Ok */0) {
          var allowed_goods_type_names = Decco.arrayFromJson(allowed_goods_type_name_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "allowed_goods_type_names"), null));
          if (allowed_goods_type_names.TAG === /* Ok */0) {
            var value_added_services = Decco.arrayFromJson(value_added_service_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "value_added_services"), null));
            if (value_added_services.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        id: id._0,
                        display_name: display_name._0,
                        details: details._0,
                        icons: icons._0,
                        allowed_goods_type_names: allowed_goods_type_names._0,
                        value_added_services: value_added_services._0
                      }
                    };
            }
            var e = value_added_services._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".value_added_services" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = allowed_goods_type_names._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".allowed_goods_type_names" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = icons._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".icons" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = details._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".details" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = display_name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".display_name" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function vehicles_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var on_demand = Decco.arrayFromJson(on_demand_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "on_demand"), null));
  if (on_demand.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              on_demand: on_demand._0
            }
          };
  }
  var e = on_demand._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".on_demand" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var vehicles = vehicles_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "vehicles"), null));
  if (vehicles.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              vehicles: vehicles._0
            }
          };
  }
  var e = vehicles._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".vehicles" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  details_decode ,
  icons_decode ,
  service_decode ,
  value_added_service_decode ,
  allowed_goods_type_name_decode ,
  on_demand_decode ,
  vehicles_decode ,
  t_decode ,
  
}
/* No side effect */
